export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Top area */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <a href="#hero" className="font-heading text-xl font-bold text-primary-500 mb-3 block cursor-pointer">
              五姑娘影院
            </a>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              五姑娘影院电影大全汇集热门电影、高分电影和动作片等各类资源，高清免费在线观看不缓冲。最新大片及时更新，满足您的观影需求。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#cards" className="block text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选分类</a>
              <a href="#ranking" className="block text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
              <a href="#media" className="block text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">影音推荐</a>
              <a href="#index" className="block text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">影片分类</h4>
            <div className="flex flex-wrap gap-2">
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">动作片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">科幻片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">喜剧片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">悬疑片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">爱情片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">动画片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">恐怖片</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200/50 text-foreground-500 text-xs border border-background-300/30 whitespace-nowrap">犯罪片</span>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              合作伙伴招募中，敬请期待
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-300/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 五姑娘影院. 本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <span className="whitespace-nowrap">每日更新50+部</span>
            <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
            <span className="whitespace-nowrap">1080P高清画质</span>
            <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
            <span className="whitespace-nowrap">不缓冲不卡顿</span>
          </div>
        </div>
      </div>
    </footer>
  );
}